const Logo = () => {
    return (
        <div className="h-50 flex items-center p-10 pl-10">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 mr-2" fill="#fff" stroke="#fff" viewBox="0 0 20 20">
                <path fill="#fff" fill-rule="evenodd" stroke="none" d="M2.938 12.948 9 4.804V16.5l-6.062-3.552Zm14.125 0L11 16.5V4.804l6.063 8.144ZM11.001 1.454 10 0 9 1.454 0 13.545l9 5.273 1 .539 1.001-.539L20 13.545 11.001 1.454Z"/>
            </svg>
            <span className="font-inter font-semibold text-5xl leading-normal text-left tracking-tighter text-white">
                SoftLink
            </span>
        </div>

    );
};

export default Logo